import { Box, Button, FlexBox, Icon, Typography } from '@vp/swan';
import React, { useContext, useEffect, useState } from 'react';

import './MessageFeedback.styles.scss';
import { useCustomTracking } from '../../hooks/custom-hooks/useTracking';
import { CAContext } from '../../contexts/CAContext';
import FeedbackPopover from './FeedbackPopover';

export interface IMessageFeedbackProps {
  bubbleWidth: number;
  messageId: string;
}

const MessageFeedback: React.FC<IMessageFeedbackProps> = ({ bubbleWidth, messageId }) => {
  const {
    chatState: { scrollToBottom },
  } = useContext(CAContext);
  const { sendTrackingEvent } = useCustomTracking();
  const [displayText, setDisplayText] = useState<string>('Good answer?');
  const [showPopover, setShowPopover] = useState<boolean>(false);
  const [activeButton, setActiveButton] = useState<'like' | 'dislike' | null>(null);

  const handleSendFeedback = (feedbackMessage: string) => {
    sendTrackingEvent('Chatbot Clicked', 'Chatbot:Feedback', 'botFeedbackSubmitted', undefined, { feedbackText: feedbackMessage, messageId, reaction: 'down' });
    setShowPopover(false);
    setDisplayText('Thanks!');
    // setShowFeedback(false);
  };

  const handleLike = () => {
    setDisplayText('Thanks!');
    setShowPopover(false);
    setActiveButton('like');
    sendTrackingEvent('Chatbot Clicked', 'Chatbot:Feedback', 'botFeedbackReaction', undefined, { messageId, reaction: 'up' });
  };

  const handleDislike = () => {
    setShowPopover(true);
    setDisplayText('Tell us why:');
    setActiveButton('dislike');
    sendTrackingEvent('Chatbot Clicked', 'Chatbot:Feedback', 'botFeedbackReaction', undefined, { messageId, reaction: 'down' });
  };

  const handleClosePopover = () => {
    setShowPopover(false);
    setDisplayText('Thanks!');
  };

  useEffect(() => {
    if (showPopover) {
      sendTrackingEvent('Chatbot Viewed', 'Chatbot:Feedback', 'botFeedbackTextOpened', undefined, { messageId });
      scrollToBottom?.(`feedback-popover-${messageId}`);
    }
  }, [showPopover]);
  const [isInitialEventSent, setIsInitialEventSent] = useState(false);
  useEffect(() => {
    if (!isInitialEventSent) {
      sendTrackingEvent('Chatbot Viewed', 'Chatbot:Feedback', 'botFeedbackPromptShown', undefined, { messageId });
      setIsInitialEventSent(true);
    }
  }, [isInitialEventSent]);
  return (
    <FlexBox flexDirection="column" compactMode marginTop={2}>
      <FlexBox style={{ width: `${bubbleWidth + 20}px` }} gap="between-actions" compactMode justifyContent="flex-end">
        <Typography fontSkin="body-small" textColor="subtle" style={{ alignContent: 'center' }} className="message-feedback-text" key={displayText}>
          {displayText}
        </Typography>
        <FlexBox gap="0">
          <Button onClick={handleLike} className={`message-feedback-button ${activeButton === 'like' ? 'active' : ''}`} padding={4}>
            <Icon iconType="like" size="20p" />
          </Button>
          <Button className={`message-feedback-button ${activeButton === 'dislike' ? 'active' : ''}`} onClick={handleDislike} padding={4}>
            <Icon iconType="dislike" size="20p" />
          </Button>
        </FlexBox>
      </FlexBox>
      <FlexBox>
        {showPopover && (
          <Box className={'message-feedback-popover'} padding={5} marginTop={3} mx={5} compactMode>
            <FeedbackPopover onClose={handleClosePopover} onSendFeedback={handleSendFeedback} id={`feedback-popover-${messageId}`} />{' '}
          </Box>
        )}
      </FlexBox>
    </FlexBox>
  );
};

export default MessageFeedback;
